import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-100 relative h-4"
}
const _hoisted_2 = { class: "invisible absolute -ml-1 flex flex-col rounded border border-gray-200 bg-gray-50 px-2 group-hover:visible" }

import { computed, ComputedRef } from 'vue';
import {
    CallModel,
    CallTranscriptModel,
    CallParticipantType,
    CallBulletType,
    CallPlayerGetters,
} from '@/types';
import { PlayIcon } from '@heroicons/vue/solid';

import store from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'CallPlayerBullets',
  props: {
    call: {
        type: Object as () => CallModel,
        required: true,
    },
    callDuration: {
        type: Number,
        required: true,
    },
    bulletType: {
        type: String as () => CallBulletType,
        required: true,
    },
    participantType: {
        type: String as () => CallParticipantType,
        required: true,
    },
},
  emits: ['playSnippet'],
  setup(__props, { emit: __emit }) {



const isBulletTypeRegistered = __props.bulletType === CallBulletType.registered;
const isBulletTypeMatched = __props.bulletType === CallBulletType.matched;

const emit = __emit;

const callPlayerSearchQuery: ComputedRef<string> = computed(
    () => store.getters[CallPlayerGetters.SEARCH_QUERY],
);
const callPlayerSelectedWords: ComputedRef<string[]> = computed(() => {
    const selectedWordsMap = store.getters[CallPlayerGetters.SELECTED_WORDS];
    return Array.from(selectedWordsMap.get(__props.participantType) ?? []);
});

const bullets = computed(() => {
    if (!__props.call?.transcripts) return [];

    return __props.call.transcripts
        .filter(({ participant }) => participant === __props.participantType)
        .map((transcript) => {
            const matchedWords = transcript.words.filter((word) => {
                const query = callPlayerSearchQuery.value;
                const selectedWords = callPlayerSelectedWords.value;
                return word === query || selectedWords.includes(word);
            });

            return {
                ...transcript,
                matchedWords,
            };
        })
        .filter(({ registeredWords = [], matchedWords = [] }) => {
            return (
                (isBulletTypeRegistered && registeredWords.length > 0) ||
                (isBulletTypeMatched && matchedWords.length > 0)
            );
        });
});

function playSnippet(start: number, end: number) {
    emit('playSnippet', start, end);
}

function getBulletPosition(item: CallTranscriptModel) {
    return (item.startedAt / __props.callDuration) * 100 + '%';
}

function getWordsByBulletType(transcript: CallTranscriptModel): string[] {
    let words: string[] = [];

    if (isBulletTypeRegistered) words = transcript.registeredWords;
    else if (isBulletTypeMatched) words = transcript.matchedWords;

    const uniqueSortedWords = [...new Set(words)].sort();

    return uniqueSortedWords;
}

const variant = __props.bulletType == CallBulletType.registered ? 'blue' : 'orange';
const playColor = `text-${variant}-500`;
const bulletColor = `bg-${variant}-500/50`;

return (_ctx: any,_cache: any) => {
  return (__props.callDuration)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bullets.value, (bullet) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `bullet-${__props.bulletType}-${__props.participantType}-${bullet.id}`,
            class: _normalizeClass(["group absolute h-4 w-4 rounded-full p-0 hover:-m-2 hover:h-8 hover:w-8 hover:bg-gray-50 hover:transition-all", bulletColor]),
            style: _normalizeStyle({ left: getBulletPosition(bullet) })
          }, [
            _createVNode(_unref(PlayIcon), {
              class: _normalizeClass(["invisible h-full w-full cursor-pointer group-hover:visible", playColor]),
              onClick: ($event: any) => (playSnippet(bullet.startedAt, bullet.endedAt))
            }, null, 8, ["onClick"]),
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getWordsByBulletType(bullet), (word) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `bullet-${__props.bulletType}-${__props.participantType}-${bullet.id}-${word}`,
                  class: "z-50 whitespace-nowrap text-gray-700"
                }, _toDisplayString(word), 1))
              }), 128))
            ])
          ], 4))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})